import { render, staticRenderFns } from "./SubjectTeacherList.vue?vue&type=template&id=b8ba4e5e"
import script from "../../../controllers/custom/subject_teacher/subject_teacher-list.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/subject_teacher/subject_teacher-list.js?vue&type=script&lang=js&external"
import style0 from "./SubjectTeacherList.vue?vue&type=style&index=0&id=b8ba4e5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports